<template>
  <div class="card">
    <!-- 处方标签 -->
    <PStatusLabel :info="info.msgObject" />
    <div class="card-header">处方详情</div>
    <div class="card-body">
      <div class="flex-box">
        <div><auth-img class="icon" src="@/assets/img/chat/prescription.png" /></div>
        <div class="drug-list" v-if="toJson(info.msgObject.chineseMedicationItems)?.length > 0">
          中药处方
        </div>
        <div class="drug-list" v-else>
          <div class="auxiliary" v-for="c in detailDrugs" :key="c.name">
            <span>{{ c.name }}</span>
          </div>
        </div>
      </div>
      <div class="auxiliary-tips">请尽快购买处方，并按时服药</div>
      <RetreatmentInfo
        v-if="info.msgObject.reserveDate"
        :info="info.msgObject"
        :retreatInfo="{
          margin: '4px 0 5px 0'
        }"
      />
    </div>
    <!-- <div @click="handleClick" class="card-footer">查看详情</div> -->
    <div class="card-footer-flex">
      <div @click="handleClick" class="btn">查看详情</div>
      <div v-if="info.msgObject.chatSummaryId" @click="handleOpen" class="btn">未购原因</div>
    </div>
  </div>
</template>
<script setup>
import RetreatmentInfo from '../retreatment/cardRetreatInfo.vue'
import { defineProps, defineEmits } from 'vue'
import PStatusLabel from '../PStatusLabel/index.vue'
defineProps({
  info: {
    type: Object,
    default: () => {},
    required: true
  },
  detailDrugs: {
    type: Array,
    default: () => []
  }
})
const emit = defineEmits(['handleClick'])
const handleClick = () => {
  emit('handleClick')
}
const toJson = (str = '[]') => {
  const _str = JSON.parse(str)
  return _str
}
const handleOpen = () => {
  emit('handleOpen')
}
</script>
<style scoped lang="scss">
.card {
  position: relative;
  .auxiliary-tips {
    font-weight: 400;
    font-size: 14px;
    color: #7d7d7d;
    padding: 8px 0;
  }
  .flex-box {
    display: flex;
    gap: 8px;
    .icon {
      width: 24px;
      height: 18px;
      display: block;
    }
    .drug-list {
      flex: 1;
      line-height: 18px;
      .auxiliary {
        font-weight: 500;
        font-size: 16px;
        color: #1c1c1c;
        span {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
      }
      .auxiliary:first-child {
        margin-top: 0;
      }
    }
  }

  &-header {
    font-size: 16px;
    color: #1a1a1a;
    font-weight: bold;
    padding: 12px;
    border-bottom: 1px solid #fafafa;
    text-align: left;

    span {
      font-size: 12px;
      color: #999999;
      padding-left: 8px;
    }
  }

  &-body {
    font-size: 14px;
    color: #3b3b3b;
    padding: 12px;
    text-align: left;

    .auxiliary {
      font-size: 14px;
      color: #4c6ee0;
      margin-top: 8px;
    }
  }

  &-footer {
    border-top: 1px solid #fafafa;
    padding: 12px;
    font-size: 16px;
    color: #3f64ff;
    text-align: center;
    cursor: pointer;
  }
  .card-footer-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .btn {
      border-top: 1px solid #fafafa;
      padding: 12px;
      font-size: 16px;
      color: #3f64ff;
      text-align: center;
      cursor: pointer;
      flex: 1;
      border-right: 1px solid #fafafa;

      &:last-child {
        border-right: none;
      }
    }
  }
}
</style>
